import i18n from '@/plugins/i18n.js';

const options =
  [
    { value: 1, text: i18n.t("servicesystem.common_objects.appointment.types.specified_time_and_technician") },
    { value: 2, text: i18n.t("servicesystem.common_objects.appointment.types.available_technician") },
    { value: 3, text: i18n.t("servicesystem.common_objects.appointment.types.all_technicians") },
  ];

export default options;